import script from "./recent-deals.vue?vue&type=script&setup=true&lang=js"
export * from "./recent-deals.vue?vue&type=script&setup=true&lang=js"

import "./recent-deals.vue?vue&type=style&index=0&id=7683048a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7683048a"]])

export default __exports__